var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClienteIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.094 13.0228V11.6428C11.094 10.9113 10.8034 10.2098 10.2862 9.69257C9.76898 9.17534 9.06747 8.88477 8.336 8.88477H3.508C2.77653 8.88477 2.07502 9.17534 1.5578 9.69257C1.04057 10.2098 0.75 10.9113 0.75 11.6428V13.0218",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.63807 3.508C8.63807 4.05344 8.47634 4.58663 8.17333 5.04016C7.87032 5.49369 7.43964 5.84719 6.93574 6.05596C6.43184 6.26474 5.87735 6.31942 5.34238 6.21308C4.80741 6.10674 4.31598 5.84417 3.93022 5.45855C3.54447 5.07294 3.28172 4.58161 3.17519 4.04667C3.06866 3.51174 3.12313 2.95723 3.33172 2.45325C3.54032 1.94928 3.89366 1.51847 4.34708 1.21529C4.8005 0.91212 5.33363 0.750198 5.87907 0.75C6.61054 0.75 7.31205 1.04057 7.82927 1.5578C8.3465 2.07502 8.63707 2.77653 8.63707 3.508H8.63807Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6816 4.13867V8.27667",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7503 6.20508H11.6123",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClienteIco);
export default __webpack_public_path__ + "static/media/cliente-ico.da23085cff29a093092e7d6699fd56fe.svg";
export { ForwardRef as ReactComponent };